import { styled } from '@mui/material';
import { Autocomplete } from '@totalsoft/rocket-ui';

export const ContextAutocomplete = styled(Autocomplete)(({ theme }) => ({
  '& .MuiInputBase-input': {
    color: 'inherit',
    fontWeight: theme.typography.fontWeightBold
  },
  '& .MuiAutocomplete-popupIndicator,& .MuiInputAdornment-root': {
    color: 'inherit'
  },
  '& .MuiInputBase-root': {
    color: 'inherit',
    '&::before': {
      borderColor: `inherit !important`
    },
    '&::after': {
      display: 'none'
    }
  }
}));
